<template>
  <v-select
    :value="time_readable"
    :items="TimepickerItems"
    dense
    hide-details
    class="mm-timepicker mt-0"
    @change="$emit('input', $event)"
  />
</template>

<script>
import { format, parseISO } from 'date-fns'
import * as TimeFormats from '@/constants/TimeFormats'
import TimepickerItems from '@/constants/TimepickerItems'
export default {
  name: 'AdminInputTimepicker',
  props: {
    timestamp: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  computed: {
    time_readable() {
      return this.timestamp
        ? format(parseISO(this.timestamp), TimeFormats.time12hr)
        : TimepickerItems[0]
    },
  },
  data() {
    return {
      TimepickerItems,
    }
  },
}
</script>

<style lang="scss">
.mm-timepicker {
  .v-select__selections {
    align-self: flex-end;
    input {
      padding: 2px 0;
    }
  }
  .v-select__selection {
    margin: 0 !important;
  }
}
</style>
